// UM.8 — grid-saataejaet: zoom (tilekoko) + aspect-ratio Selaa-gridissaeae.
// Slider:n pikseliarvot CSS auto-fill minWidth:lle, imgSize ohjaa
// AssetThumbnail:n ?size= -pyynnoeae (256 pieni, 1024 iso). Aspect-ratio
// muuttuu pelkaeaen CSS-kontainerin muotoa — kuvalla on object-cover joten
// se kropataan automaattisesti uuteen muotoon ilman uusia thumbnail-uploads.

export const GRID_ZOOM_LEVELS = [
  { label: "XS", minWidth: 120, imgSize: 256 as const },
  { label: "S", minWidth: 180, imgSize: 256 as const },
  { label: "M", minWidth: 240, imgSize: 256 as const },
  { label: "L", minWidth: 340, imgSize: 1024 as const },
  { label: "XL", minWidth: 480, imgSize: 1024 as const },
] as const;

export type GridZoom = 0 | 1 | 2 | 3 | 4;

export const DEFAULT_GRID_ZOOM: GridZoom = 2;

export type GridZoomSliderProps = {
  value: GridZoom;
  onChange: (value: GridZoom) => void;
};

// Aspect-ratio-vaihtoehdot. Avaimet ovat sekae state-arvoja ettae UI-labelin
// pohja. Tailwind:n JIT skannaa nama luokat staattisina, joten kaytetaen
// kiinteaae mappausta — ei dynaamista template-stringia.
export const GRID_ASPECTS = ["16/9", "4/3", "1/1", "3/4", "9/16"] as const;
export type GridAspect = (typeof GRID_ASPECTS)[number];
export const DEFAULT_GRID_ASPECT: GridAspect = "4/3";

export const GRID_ASPECT_CLASS: Record<GridAspect, string> = {
  "16/9": "aspect-[16/9]",
  "4/3": "aspect-[4/3]",
  "1/1": "aspect-square",
  "3/4": "aspect-[3/4]",
  "9/16": "aspect-[9/16]",
};

const ASPECT_LABEL: Record<GridAspect, string> = {
  "16/9": "16:9",
  "4/3": "4:3",
  "1/1": "1:1",
  "3/4": "3:4",
  "9/16": "9:16",
};

export type GridAspectToggleProps = {
  value: GridAspect;
  onChange: (value: GridAspect) => void;
};

export function GridAspectToggle({ value, onChange }: GridAspectToggleProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Tilen sivusuhde"
      className="inline-flex items-center rounded-md border border-slate-800 bg-slate-900 p-0.5 text-xs"
    >
      {GRID_ASPECTS.map((a) => {
        const active = value === a;
        return (
          <button
            key={a}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(a)}
            className={
              "rounded px-2 py-1 transition " +
              (active
                ? "bg-slate-100 text-slate-900"
                : "text-slate-400 hover:bg-slate-800 hover:text-slate-200")
            }
            title={`Sivusuhde ${ASPECT_LABEL[a]}`}
          >
            {ASPECT_LABEL[a]}
          </button>
        );
      })}
    </div>
  );
}

export function GridZoomSlider({ value, onChange }: GridZoomSliderProps) {
  return (
    <div className="inline-flex items-center gap-2">
      <span aria-hidden className="text-slate-500">−</span>
      <input
        type="range"
        min={0}
        max={4}
        step={1}
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value, 10) as GridZoom)}
        className="h-1 w-28 cursor-pointer accent-cyan-500"
        aria-label="Thumbnail-koko"
        title={`Koko: ${GRID_ZOOM_LEVELS[value].label}`}
      />
      <span aria-hidden className="text-slate-500">+</span>
      <span className="ml-1 inline-block w-6 text-center text-xs font-medium text-slate-400">
        {GRID_ZOOM_LEVELS[value].label}
      </span>
    </div>
  );
}
